import React, { useState, useEffect } from 'react'
import { Link, useHistory } from 'react-router-dom'
import { useAuth, useProtectedPage } from '../../../context/AuthContext'
import useCallApi from '../../../hooks/useCallApi'
import callAPI from '../../../helpers/callAPI'

import Loading from '../../../templates/UI/Loading/Loading'
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Modal } from 'reactstrap'
import '../../../templates/Layout/Toolbar/Toolbar.css'

export default function AvatarTemplateManager(props) {

    document.title = 'Avatar Question Template Manager'

    const auth = useAuth()
    useProtectedPage(auth.permissions, 'avatar')
    const history = useHistory()
    const [dropdownOpen, setDropdownOpen] = useState([false])
    const [newSurveyAdded, setNewSurveyAdded] = useState(false)
    const [deleteModalOpen, setDeleteModalOpen] = useState(false)
    const [deleteTemplateId, setDeleteTemplateId] = useState(null)

    const showSystemMessage = props.showSystemMessage
    const { data, dataLoaded, refetch } = useCallApi(`avatar/questionTemplates`, 'GET', {}, [])

    useEffect(() => {
        let tempDropDown = []
        dataLoaded &&
            data.questionTemplates.forEach((template) => {
                tempDropDown[template.template_id] = false
            }
            )
        setDropdownOpen(tempDropDown)
        console.log('Dropdown state initialized:', tempDropDown)

    }, [data.questionTemplates, dataLoaded])


    useEffect(() => {
        setNewSurveyAdded(false)
    }, [newSurveyAdded]) // Passing an array as second argument = componentDidMount


    const handleDeleteSurvey = async (templateId) => {
        console.log('Deleting template with ID:', templateId)
        // Here we would delete the survey from the database
        if (deleteModalOpen) {
            let result = await callAPI(`avatar/questionTemplate/${deleteTemplateId}`, 'DELETE', {})
            refetch()
            setDeleteModalOpen(false)
            if (!result.success) {
                showSystemMessage('error', `${result.errors.message}`)
                return
            }
            showSystemMessage('success', 'Template deleted successfully')
        } else {
            setDeleteTemplateId(templateId)
            setDeleteModalOpen(true)
        }
    }



    return (
        <React.Fragment>
            <div className="page-header d-flex align-items-center">
                <h1 className="mb-h1">Avatar Question Template Manager</h1>
            </div>
            <Modal isOpen={deleteModalOpen} toggle={() => setDeleteModalOpen(false)} className="modal-md">
                <div className="modal-header">
                    <h5 className="modal-title">Delete Template</h5>
                    <button type="button" className="close" onClick={() => setDeleteModalOpen(false)}>
                        <span aria-hidden="true">x</span>
                    </button>
                </div>
                <div className="modal-body">
                    Are you sure you want to delete this template? This action cannot be undone.
                    Any linked questions will be unlinked and any further changes to them will need to be done manually.
                </div>
                <div className="modal-footer">
                    <button className="btn btn-secondary" onClick={() => setDeleteModalOpen(false)}>
                        Cancel
                    </button>
                    <button className="btn btn-danger" onClick={() => handleDeleteSurvey(props.templateId)}>
                        Delete
                    </button>
                </div>
            </Modal>
            {dataLoaded ? (
                <div className="row">
                    <div className="col-md-8">
                        <div className="card">
                            <div className="card-header d-flex justify-content-between align-items-center">
                                <h1 className="mb-h1-dark">Question Template Manager</h1>
                                <Link to="/avatar/questionTemplate/new" className="btn btn-sm btn-warning">
                                    + New Question Template
                                </Link>
                            </div>
                            <div className="card-body p-0">
                                <table className="table table-striped table-hover">
                                    <thead>
                                        <tr>
                                            <th scope="col">Template ID</th>
                                            <th scope="col">Type</th>
                                            <th scope="col">Name</th>
                                            <th scope="col">Question</th>
                                            <th scope="col">Active Surveys</th>
                                            <th scope="col" className="text-end" width='160px' />
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data.questionTemplates.map((template) => {
                                            return (
                                                <tr key={template.template_id}>
                                                    <td>{template.template_id}</td>
                                                    <td>{template.question_type}</td>
                                                    <td>{template.name}</td>
                                                    <td>{template.question_description}</td>
                                                    <td>
                                                        <Dropdown isOpen={dropdownOpen[template.template_id]} toggle={() => {
                                                            let tempDropDown = [...dropdownOpen]
                                                            tempDropDown[template.template_id] = !tempDropDown[template.template_id]
                                                            setDropdownOpen(tempDropDown)
                                                        }} classname='navbar-dark'>
                                                            <DropdownToggle 
                                                                tag="a" 
                                                                onClick={(e) => e.preventDefault()}
                                                                //secondary color
                                                                className="dropdown-toggle text-dark btn btn-light border"
                                                            >
                                                                View Active Surveys
                                                            </DropdownToggle>
                                                            <DropdownMenu className="dropdown-menu-dark">
                                                                {template.surveys.length > 0 ? (
                                                                    template.surveys.map((survey, index) => (<>
                                                                        {index != 0 && <DropdownItem divider className="m-0" />}
                                                                        <a target="_blank" href={`/avatar/survey/${survey.surveyId}`} onClick={() => {
                                                                            let tempDropDown = [...dropdownOpen]
                                                                            tempDropDown[template.template_id] = false
                                                                            setDropdownOpen(tempDropDown)
                                                                        }}
                                                                        className='dropdown-item' 
                                                                        size='sm'>
                                                                            {survey.surveyDescription} ({survey.surveyId})
                                                                        </a>
                                                                    </>
                                                                    ))
                                                                ) : (
                                                                    <DropdownItem disabled>No active surveys</DropdownItem>
                                                                )}
                                                            </DropdownMenu>
                                                        </Dropdown>
                                                    </td>
                                                    <td>
                                                        <div className="d-flex justify-content-end">
                                                            <Link
                                                                to={`/avatar/questionTemplate/${template.template_id}`}
                                                                className="btn btn-sm btn-primary me-2"
                                                            >
                                                                Edit
                                                            </Link>
                                                            <button
                                                                className="btn btn-danger btn-sm ml-2"
                                                                onClick={() => handleDeleteSurvey(template.template_id)}
                                                            >
                                                                Delete Template
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div style={{ marginTop: '4rem' }}>
                    <Loading />
                </div>
            )}
        </React.Fragment>
    )
}

